export default {
    "name": "UpdateSalesOrderBasicFields",
    "kind": "HoudiniMutation",
    "hash": "386c1fdc0a00ff0ed9b3d81ed2349466f68cc5a49c94994b098a29c6b24428e9",

    "raw": `mutation UpdateSalesOrderBasicFields($input: SalesOrderUpdate!) {
  updateSalesOrder(input: $input) {
    id
    date
    externalComments
    internalComments
    purchaseOrderNumber
    truckNumber
  }
}
`,

    "rootType": "Mutation",
    "stripVariables": [],

    "selection": {
        "fields": {
            "updateSalesOrder": {
                "type": "SalesOrder",
                "keyRaw": "updateSalesOrder(input: $input)",

                "selection": {
                    "fields": {
                        "id": {
                            "type": "ID",
                            "keyRaw": "id",
                            "visible": true
                        },

                        "date": {
                            "type": "Date",
                            "keyRaw": "date",
                            "visible": true
                        },

                        "externalComments": {
                            "type": "String",
                            "keyRaw": "externalComments",
                            "visible": true
                        },

                        "internalComments": {
                            "type": "String",
                            "keyRaw": "internalComments",
                            "visible": true
                        },

                        "purchaseOrderNumber": {
                            "type": "String",
                            "keyRaw": "purchaseOrderNumber",
                            "visible": true
                        },

                        "truckNumber": {
                            "type": "String",
                            "keyRaw": "truckNumber",
                            "nullable": true,
                            "visible": true
                        }
                    }
                },

                "visible": true
            }
        }
    },

    "pluginData": {
        "houdini-svelte": {
            "isManualLoad": true
        }
    },

    "input": {
        "fields": {
            "input": "SalesOrderUpdate"
        },

        "types": {
            "SalesOrderUpdate": {
                "date": "Date",
                "externalComments": "String",
                "internalComments": "String",
                "purchaseOrderNumber": "String",
                "salesOrderId": "UInt",
                "storeId": "UInt",
                "truckNumber": "String"
            }
        },

        "defaults": {},
        "runtimeScalars": {}
    }
};

"HoudiniHash=1888631b8e3ebe5c7a99e0b1a758a63b49531611699f115ea23824fc1f64e691";